import React, { useEffect, useState } from 'react';
import { MainContainer, MainHeading, ParaText } from '../../style/GlobalStyles';
import { Box, useTheme } from '@mui/material';
import ShowAddedCompanyBox from '../../components/ShowAddedCompanyBox';
import FilterByCompany from '../../components/FilterByCompany';
import { skeleton } from './skeleton';
import PaymentInvoiceTableAndList from './PaymentInvoiceTableAndList';
import { useSelector, useDispatch } from 'react-redux';
import { selectBillingData, selectBillingStatus, selectBillingError, initializeAsync } from './billingSlice';
import { useAuth } from '../../hooks/useAuth';
import { post } from '../../api';

export function BillingHistoryPage() {
    const data = useSelector(selectBillingData);
    const status = useSelector(selectBillingStatus);
    const error = useSelector(selectBillingError);
    const dispatch = useDispatch();

    const [loading, setLoading] = React.useState(true);
    const [selectedCompanyList, setSelectedCompanyList] = useState([]);
    const [hasPersonalProducts, setHasPersonalProducts] = useState();

    const theme = useTheme();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    useEffect(() => {
        if (status === 'idle') {
            dispatch(initializeAsync({ accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }));
        }
    }, [status, dispatch]);

    useEffect(() => {
        post('custom/checkUserHasPersonalProduct', { accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }).then((result) => {
            if (result.isSuccess && result.data === 'true') {
                setHasPersonalProducts(true);
            } else {
                setHasPersonalProducts(false);
            }
        });
    }, []);

    const handleCompanyFilterChange = (selectedCompanyIds) => setSelectedCompanyList(selectedCompanyIds);

    const FilterButtonUI = () => {
        return <FilterByCompany hideHousehold={!hasPersonalProducts} selectedCompanyList={selectedCompanyList} onChange={handleCompanyFilterChange} />;
    };

    const FilteredItemListUI = <ShowAddedCompanyBox selectedCompanyList={selectedCompanyList} sx={{ margin: 0 }} />;

    const getBillingHistory = () => {
        const getList = data?.records ? data?.records : [];

        if (selectedCompanyList.length > 0) {
            return getList.filter((cItem) => {
                return selectedCompanyList.find((t) => t.id === cItem.accountId);
            });
        } else {
            return getList;
        }
    };

    return status === 'initialLoading' ? (
        skeleton
    ) : (
        <MainContainer>
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <MainHeading>Billing History</MainHeading>
                {hasPersonalProducts != undefined && (
                    <Box
                        display={{
                            xs: 'none',
                            sm: 'block',
                        }}
                    >
                        {FilterButtonUI()}
                    </Box>
                )}
            </Box>
            <ParaText marginTop={theme.typography.generic.xSmall}>Keep track of your payment history and download invoices with a click.</ParaText>

            <Box margin={`${theme.typography.generic.xxxxxLarge} ${theme.typography.generic.none}`}>
                {hasPersonalProducts != undefined && (
                    <Box
                        display={{
                            xs: 'block',
                            sm: 'none',
                        }}
                        marginBottom={{ xs: theme.typography.generic.xLarge, sm: 'unset' }}
                    >
                        {FilterButtonUI()}
                    </Box>
                )}
                {selectedCompanyList.length > 0 && FilteredItemListUI}
            </Box>

            <PaymentInvoiceTableAndList tableBodyRowList={getBillingHistory()} />
        </MainContainer>
    );
}

export default BillingHistoryPage;
